export default {
  payment_methods: {
    sofort: 'Sofort',
    giropay: 'Giropay',
    iban: "EC-Card / IBAN",
    cash: 'Cash',
  },
};
